export const SAMPLE_ZEE_USERS = [
  {
    id: '550e8400-e29b-41d4-a716-446655440000',
    name: 'John Doe',
    photo_url:
      'https://images.unsplash.com/photo-1502685104226-ee32379fefbe?w=200&h=200&fit=crop&crop=faces',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440001',
    name: 'Sarah Smith',
    photo_url:
      'https://images.unsplash.com/photo-1527980965255-d3b416303d12?w=200&h=200&fit=crop&crop=faces',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440002',
    name: 'Michael Johnson',
    photo_url:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440003',
    name: 'Emily Davis',
    photo_url:
      'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=200&h=200&fit=crop&crop=faces',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440004',
    name: 'David Wilson',
    photo_url:
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=200&h=200&fit=crop&crop=faces',
  },
];

export const SAMPLE_TERRITORY_LIKES = [
  {
    id: '550e8400-e29b-41d4-a716-446655440013',
    name: 'John Doe',
    photo_url: 'https://ui-avatars.com/api/?name=John+Doe&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440014',
    name: 'Sarah Smith',
    photo_url: 'https://ui-avatars.com/api/?name=Sarah+Smith&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440015',
    name: 'Michael Johnson',
    photo_url:
      'https://ui-avatars.com/api/?name=Michael+Johnson&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440016',
    name: 'Emily Davis',
    photo_url: 'https://ui-avatars.com/api/?name=Emily+Davis&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440017',
    name: 'David Wilson',
    photo_url:
      'https://ui-avatars.com/api/?name=David+Wilson&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440018',
    name: 'Jennifer Brown',
    photo_url:
      'https://ui-avatars.com/api/?name=Jennifer+Brown&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440019',
    name: 'Robert Taylor',
    photo_url:
      'https://ui-avatars.com/api/?name=Robert+Taylor&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440020',
    name: 'Lisa Anderson',
    photo_url:
      'https://ui-avatars.com/api/?name=Lisa+Anderson&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440021',
    name: 'William Martinez',
    photo_url:
      'https://ui-avatars.com/api/?name=William+Martinez&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440022',
    name: 'Patricia Thompson',
    photo_url:
      'https://ui-avatars.com/api/?name=Patricia+Thompson&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440023',
    name: 'James Garcia',
    photo_url:
      'https://ui-avatars.com/api/?name=James+Garcia&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440024',
    name: 'Linda Robinson',
    photo_url:
      'https://ui-avatars.com/api/?name=Linda+Robinson&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440025',
    name: 'Charles Clark',
    photo_url:
      'https://ui-avatars.com/api/?name=Charles+Clark&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440026',
    name: 'Barbara Lewis',
    photo_url:
      'https://ui-avatars.com/api/?name=Barbara+Lewis&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440027',
    name: 'Thomas Lee',
    photo_url: 'https://ui-avatars.com/api/?name=Thomas+Lee&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440028',
    name: 'Margaret Walker',
    photo_url:
      'https://ui-avatars.com/api/?name=Margaret+Walker&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440029',
    name: 'Daniel Hall',
    photo_url: 'https://ui-avatars.com/api/?name=Daniel+Hall&background=random',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440030',
    name: 'Susan Allen',
    photo_url: 'https://ui-avatars.com/api/?name=Susan+Allen&background=random',
  },
];

export const SAMPLE_TERRITORY_DEMOGRAPHIC = [
  {
    id: '550e8400-e29b-41d4-a716-446655440031',
    label: 'Population',
    value: 1000000,
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440032',
    label: 'Median Age',
    value: 35,
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440033',
    label: 'Median Income',
    value: 50000,
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440034',
    label: 'Median Home Value',
    value: 300000,
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440035',
    label: 'Median Household Income',
    value: 50000,
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440036',
    label: 'Median Household Income',
    value: 50000,
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440037',
    label: 'Median Household Income',
    value: 50000,
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440038',
    label: 'Median Household Income',
    value: 50000,
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440039',
    label: 'Median Household Income',
    value: 50000,
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440040',
    label: 'Median Household Income',
    value: 50000,
  },
];
export const SAMPLE_PREFERRED_PERSONS = {
  AL: 13,
  AK: 17,
  AZ: 12,
  AR: 15,
  CA: 18,
  CO: 16,
  CT: 11,
  DE: 14,
  FL: 19,
  GA: 10,
  HI: 12,
  ID: 13,
  IL: 17,
  IN: 14,
  IA: 11,
  KS: 15,
  KY: 16,
  LA: 18,
  ME: 13,
  MD: 19,
  MA: 12,
  MI: 14,
  MN: 15,
  MS: 10,
  MO: 17,
  MT: 11,
  NE: 16,
  NV: 19,
  NH: 13,
  NJ: 12,
  NM: 18,
  NY: 17,
  NC: 14,
  ND: 11,
  OH: 15,
  OK: 13,
  OR: 16,
  PA: 10,
  RI: 14,
  SC: 19,
  SD: 13,
  TN: 12,
  TX: 18,
  UT: 16,
  VT: 11,
  VA: 17,
  WA: 15,
  WV: 14,
  WI: 10,
  WY: 12,
};
